import React, { Component } from 'react';
import { observer } from 'mobx-react';

import BankAccountDashboardStore from 'js/stores/pages/AdminDashboardPage/BankAccountDashboardStore';
import LoadingSpinner from '../../LoadingSpinner';

import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import Pagination from '../../DashPanel/Pagination';
import Search from '../../DashPanel/Search';
import Title from '../../DashPanel/Title';
import DropMenu from '../../DashPanel/DropMenu';
import Controls from '../../DashPanel/Controls';

import Link from './Link';
import GotoItem from './GotoItem';
import Date from './Date';
import NotFound from './NotFound';
import Image from './Image';
import User from './User';
import Label from './Label';
import Verified from './Verified';

@observer
export default class Dashboard extends Component {
  bankAccountDashboard = BankAccountDashboardStore.create({ page: parseInt(this.props['*']) || 1 });

  constructor(props) {
    super(props);
    this.bankAccountDashboard.load();
  }

  componentDidUpdate() {
    this.bankAccountDashboard.setPage(this.props['*']);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('f') && urlParams.has('q')) {
      this.bankAccountDashboard.setQueryParams({
        field: urlParams.get('f'),
        query: urlParams.get('q'),
      });
    }
  }

  render() {
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>Bank accounts</Title>
          <Controls>
            <Search model={this.bankAccountDashboard} options={{ name: 'Name' }} />
            <Pagination model={this.bankAccountDashboard} />
          </Controls>
        </Header>

        <Content>
          {this.bankAccountDashboard.isLoading ? (
            <LoadingSpinner />
          ) : this.bankAccountDashboard.bank_accounts.length ? (
            <div>
              {this.bankAccountDashboard.bank_accounts.map(bank_account => (
                <Link to={`bank_account/${bank_account.id}`} key={bank_account.id}>
                  <Image logo_type={bank_account.logo_type} logo={bank_account.logo_src} />
                  <Date>{bank_account.created_at}</Date>
                  <User>{bank_account.user_name || 'Unknown name'}</User>
                  <Label>{bank_account.bank_account}</Label>
                  <Verified verified={bank_account.is_verified} />
                  <GotoItem />
                </Link>
              ))}
            </div>
          ) : (
            <NotFound>No bank accounts found</NotFound>
          )}
        </Content>
      </DashPanel>
    );
  }
}
